import { BigPlayButton, ControlBar, LoadingSpinner, Player } from 'video-react';
import clsx from 'clsx';
import { useEffect, useState } from 'react';

interface LectureVideoPlayerProps {
    isActive: boolean | undefined;
    poster: string | undefined;
    src: string | undefined;
    onEnded?: () => void;
    onFirstPlay?: () => void;
    autoPlay?: boolean;
    posterClassName?: string;
}

export function LectureVideoPlayer({
    isActive,
    poster,
    src,
    onEnded,
    onFirstPlay,
    autoPlay,
    posterClassName,
}: LectureVideoPlayerProps) {
    const [videoStarted, setVideoStarted] = useState(false);

    const onEndedExtended = () => {
        setVideoStarted(false);
        if (onEnded) onEnded();
    };

    const onPlayExtended = () => {
        if (!videoStarted && onFirstPlay) onFirstPlay();

        setVideoStarted(true);
    };

    useEffect(() => {
        setVideoStarted(false);
    }, [isActive]);

    return (
        <div className="overflow-hidden">
            {isActive ? (
                <div className="mt-4">
                    <Player
                        preload="metadata"
                        poster={poster}
                        src={src}
                        autoPlay={autoPlay ?? false}
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        onEnded={onEndedExtended}
                        onPlay={onPlayExtended}
                    >
                        <BigPlayButton position="center" />
                        <LoadingSpinner />
                        <ControlBar
                            autoHide={true}
                            // disableDefaultControls={true}
                            // disableCompletely={true}
                        >
                            {/*<PlayToggle />*/}
                            {/*<VolumeMenuButton />*/}
                            {/*<FullscreenToggle />*/}
                        </ControlBar>
                    </Player>
                </div>
            ) : (
                <img
                    width={1920}
                    height={1080}
                    src={poster}
                    alt=""
                    className={clsx(
                        'aspect-video w-full rounded-xl bg-cloud-100',
                        posterClassName || 'mb-8 mt-4',
                    )}
                />
            )}
        </div>
    );
}
